import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './IconVisual.module.css'

interface IconVisualProps {
  children?: ReactNode
  muted?: boolean
  tight?: boolean
}

/**
 * A tinted circle behind an icon.
 */
export function IconVisual({ children, muted, tight }: IconVisualProps) {
  return (
    <div
      className={cx(styles.root, muted && styles.muted, tight && styles.tight)}
    >
      {children}
    </div>
  )
}
